import React, {useCallback, useEffect, useState} from 'react';
import { Toast } from "@bryntum/schedulerpro";
import { showConfirmationDialog } from '../../other/utils/utils.jsx';

const CompanyCamModal = ({data}) => {
  const [companyCamToken, setCompanyCamToken] = useState(null);

  useEffect(() => {
    const companyCamData = (data.project.extraBoardIntegrationsStore.data || []).find(item => item.key === 'companyCam');
    if(companyCamData) {
      setCompanyCamToken(companyCamData);
    }
  }, [data]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    /* Remove the event listener when the component unmounts  */
    return () => {
        document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'ArrowLeft') {
      prev();
    } else if (e.key === 'ArrowRight') {
      next();
    } else if (e.key === "Escape") {
      closeModal();
    }
  }, []);

  const getImages = (containerId) => {
    const columns = document.querySelector(`#${containerId}`)?.children || [];
    const images = Array.from(columns).map(column => {
      return Array.from(column.children);
    });
    return images.reduce((prev, next) => next.map((_, i) => (prev[i] || []).concat(next[i])), []).flat();
  }

  const prev = () => {
    // get the id of the current editor that the modal was opened from
    const currentGalleryContainer = document.getElementsByClassName('companycam-modal')[0].dataset.targetElementId;
    // get all images from gallery
    const imageGalleryImageContainers = getImages(currentGalleryContainer);
    // get currentPhotoId attribute from companycam-modal element
    const currentPhotoId = document.getElementsByClassName('companycam-modal')[0].dataset.currentPhotoId;
    for (let i = 0; i < imageGalleryImageContainers.length; i++) {
      if (imageGalleryImageContainers[i].querySelector('img').dataset.imageId === currentPhotoId) {
        // check if last image in gallery
        let previousImage = null;
        if (i === 0) {
          previousImage = imageGalleryImageContainers[imageGalleryImageContainers.length - 1].querySelector('img');
        } else {
          previousImage = imageGalleryImageContainers[i - 1].querySelector('img');
        }
        document.getElementsByClassName('cc-modal-image')[0].src = previousImage.dataset.imageUrl.replace(/400x400/, '1200x1200');
        document.getElementsByClassName('companycam-modal')[0].dataset.currentPhotoId = previousImage.dataset.imageId;
      }
    }
  }

  const next = () => {
    // get the id of the current editor that the modal was opened from
    const currentGalleryContainer = document.getElementsByClassName('companycam-modal')[0].dataset.targetElementId;
    // get all images from gallery
    const imageGalleryImageContainers = getImages(currentGalleryContainer);
    // get currentPhotoId attribute from companycam-modal element
    const currentPhotoId = document.getElementsByClassName('companycam-modal')[0].dataset.currentPhotoId;
    for (let i = 0; i < imageGalleryImageContainers.length; i++) {
      if (imageGalleryImageContainers[i].querySelector('img').dataset.imageId === currentPhotoId) {
        // check if last image in gallery
        let nextImage = null;
        if (i === imageGalleryImageContainers.length - 1) {
          nextImage = imageGalleryImageContainers[0].querySelector('img');
        } else {
          nextImage = imageGalleryImageContainers[i + 1].querySelector('img');
        }
        document.getElementsByClassName('cc-modal-image')[0].src = nextImage.dataset.imageUrl.replace(/400x400/, '1200x1200');
        document.getElementsByClassName('companycam-modal')[0].dataset.currentPhotoId = nextImage.dataset.imageId;
      }
    }
  }


  const trashPhoto = async () => {
    closeModal();
    const isDelete = await showConfirmationDialog({
      title: "Confirm delete?",
      message: `Are you sure you want to delete this photo?`
    })
    if (isDelete) {
      // get the id of the current editor that the modal was opened from
      const currentGalleryContainer = document.getElementsByClassName('companycam-modal')[0].dataset.targetElementId;
      // get currentPhotoId attribute from companycam-modal element
      const currentPhotoId = document.getElementsByClassName('companycam-modal')[0].dataset.currentPhotoId;
      // get all cc-image-gallery-item elements
      const imageGalleryImageContainers = getImages(currentGalleryContainer);
      for (let i = 0; i < imageGalleryImageContainers.length; i++) {
        if (imageGalleryImageContainers[i].querySelector('img').dataset.imageId === currentPhotoId) {
          // trigger click event on delete icon (this removes the image from the gallery without duplicating code to do so here)
          imageGalleryImageContainers[i].querySelector('i > div').click();
          // make api call to delete photo
          const response = await fetch(`https://api.companycam.com/v2/photos/${currentPhotoId}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${companyCamToken.value}`
            }
          }).then(response => response)
            .then(data => {
              // hide modal
              document.getElementsByClassName('companycam-modal')[0].style.display = 'none';
              return data;
            })
            .catch((error) => {
              Toast.show({
                html: `<p class="feedback-savedmsg">Something went wrong.</p>`,
                timeout: 5000,
                color: "b-red",
                rootElement: document.body
              });
              console.error(error);
            });

            return response;
        }
      }

      // hide companycam-modal
      document.getElementsByClassName('companycam-modal')[0].style.display = 'none';
    }
  }

  const closeModal = () => document.getElementsByClassName('companycam-modal')[0].style.display = 'none'

  return (
    <div className="companycam-modal">
      <div className="companycam-modal-inner">
        <button className="companycam-close-button b-fa fa-xmark"
            onClick={closeModal}></button>
            <button className="companycam-delete-button b-fa fa-trashcan"
            onClick={() => {trashPhoto()}}>
              <div className="cc-image-gallery-tooltip-container" data-tooltip="Permanently Delete"></div>
            </button>
        <img className="cc-modal-image" src="https://placehold.co/600x600" alt="CompanyCam" />
        <div className="cc-modal-next-prev">
          <button className="cc-modal-prev" onClick={() => prev()}>
            <i className="fas fa-angle-left"></i>
          </button>
          <button className="cc-modal-next" onClick={() => next()}>
            <i className="fas fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyCamModal;
